import { gql } from '@apollo/client';

import { Server } from '../../apollo/types';
import { useAppDependenciesContext } from '../../state';

type GetPatientHasMobileAndCoachAccessQuery = {
  patientHasUsedMobileAppAndHasCoachAccess: boolean;
};

type GetPatientHasMobileAndCoachAccessQueryVariables = {
  patientShortId: string;
};

export const PATIENT_HAS_MOBILE_APP_AND_COACH_ACCESS = gql`
  query PatientHasMobileAndCoachAccess($patientShortId: String!) {
    patientHasUsedMobileAppAndHasCoachAccess(patientShortId: $patientShortId)
  }
`;

export function useGetPatientHasMobileAndCoachAccess(patientShortId: string, { skip }: { skip?: boolean } = {}) {
  const { useQuery } = useAppDependenciesContext();
  const { data, loading, error, refetch } = useQuery<
    GetPatientHasMobileAndCoachAccessQuery,
    GetPatientHasMobileAndCoachAccessQueryVariables
  >(PATIENT_HAS_MOBILE_APP_AND_COACH_ACCESS, {
    variables: {
      patientShortId,
    },
    skip: !patientShortId || skip,
    context: {
      server: Server.MONOLITH,
    },
  });

  return {
    patientHasAccess: data?.patientHasUsedMobileAppAndHasCoachAccess,
    loading,
    error,
    refetch,
  };
}
